import type { PageEntity } from 'App/sandboxed-page/pageEntities';
import logError from 'App/babel/helpers/logError';
import { SandboxBridge } from './sandboxBridge';
import { rememberPageFilter } from './pageFilterMemory';

// A require(), not import(): an async chunk moves @upsales/components' CSS after the app's
// own in styles.css and flips the cascade app-wide (WEB-11676). And inside the method, not
// hoisted: pageEntityActions needs the modal services and `Tools`, absent at module load.
export class AppSandboxBridge extends SandboxBridge {
	protected openEntity(entity: PageEntity, payload: unknown, newTab: boolean): void {
		Promise.resolve()
			.then(() => {
				// eslint-disable-next-line @typescript-eslint/no-var-requires
				const { openPageEntity } = require('./pageEntityActions');
				return openPageEntity(entity, payload, (url: string) => this.navigate(url, newTab));
			})
			.catch((err: unknown) => logError(err, '[sandboxBridge] openEntity failed'));
	}

	protected rememberFilter(memoryKey: string, name: string, value: unknown): void {
		rememberPageFilter(memoryKey, name, value);
	}
}

export const sandboxBridge = new AppSandboxBridge();
